export default "__VITE_ASSET__31f3mOzY__"